module.exports = __webpack_public_path__ + "static/img/ry2.9b63925.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutLanshu/ry2.jpg
// module id = Guso
// module chunks = 0